<!--Section: Block Content-->
<div>
  <header class="page-hero">
    <div class="container page-hero__inner">
      <div class="page-hero__accent"></div>
      <h2 class="page-hero__title">{{'PRODUCTS.BASKET' | translate}}</h2>
      <div class="page-hero__toolbar">
        <app-currency-selector></app-currency-selector>
        <ng-container *ngIf="(categoryInfos$ | async) as categoryInfos">
          <app-category-buttons [categoryToAvoid]="''" [categoryInfos]="categoryInfos"
            (navigateAway)="gotoTarget($event)">
          </app-category-buttons>
        </ng-container>
      </div>
    </div>
  </header>

  <main>
    <div class="container">
      <section>
        <div class="row">
          <div class="col-lg-8">

            <!-- ── Barre de progression ──────────────────────────────────────── -->
            <app-checkout-stepper [currentStep]="state.checkoutStep" (stepChange)="goToStep($event)">
            </app-checkout-stepper>

            <!-- ── Étape 1 : Panier ─────────────────────────────────────────── -->
            <div id="checkout-step-1" class="checkout-accordion mb-3"
                 [class.checkout-accordion--open]="state.checkoutStep === 1">
              <div class="checkout-accordion__header" (click)="goToStep(1)">
                <span class="ca-badge" [class.ca-badge--done]="state.checkoutStep > 1">{{ state.checkoutStep > 1 ? '✓' : '1' }}</span>
                <span class="ca-title">{{'PRODUCTS.CART' | translate}}</span>
                <span class="ca-summary" *ngIf="state.checkoutStep !== 1">
                  {{ (nbSelectedItems$ | async) }} article(s) · {{ cartTotal }}
                </span>
                <i class="fas ca-chevron"
                   [class.fa-chevron-up]="state.checkoutStep === 1"
                   [class.fa-chevron-down]="state.checkoutStep !== 1"></i>
              </div>
              <div class="checkout-accordion__body" *ngIf="state.checkoutStep === 1">
                @if (basketFormGroup) {
                  <div [formGroup]="basketFormGroup">
                    <ng-container formArrayName="basketItems">
                      @for (itemGroup of basketItemsArray['controls']; track itemGroup; let i = $index) {
                        <app-cart-item-row
                          [itemGroup]="$any(itemGroup)"
                          [item]="state.items[i]"
                          [sizes]="sizes"
                          [isOutOfStock]="isItemOutOfStock(itemGroup.get('reference')?.value)"
                          (remove)="onToogleSelect(itemGroup.value)"
                          (lightboxOpen)="openLightbox($event)">
                        </app-cart-item-row>
                      }
                    </ng-container>
                    @if (basketItemsArray['controls'].length === 0) {
                      <p class="text-primary mb-0">
                        <i class="fas fa-info-circle mr-1"></i>{{'DO_NOT_HESITATE' | translate}}
                      </p>
                    }
                  </div>
                }
                <div class="ca-next-bar">
                  <button class="btn-step-next" (click)="goToStep(2)"
                          [disabled]="((nbSelectedItems$ | async) ?? 0) < 1 || hasOutOfStockItems">
                    {{'PRODUCTS.DELIVERY_TIME' | translate}} <i class="fas fa-arrow-right ml-2"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- ── Étape 2 : Livraison ──────────────────────────────────────── -->
            <app-delivery-step
              [checkoutStep]="state.checkoutStep"
              [deliveryMode]="state.deliveryMode"
              [pickupSubMode]="state.pickupSubMode"
              [courierAgreementChecked]="state.courierAgreementChecked"
              [shippingAddress]="state.shippingAddress"
              [canGoToPayment]="canGoToPayment"
              (headerClick)="goToStep(2)"
              (deliveryModeToggle)="toggleDeliveryMode($event)"
              (pickupSubModeToggle)="togglePickupSubMode($event)"
              (courierAgreementChange)="state.courierAgreementChecked = $event"
              (shippingAddressChange)="onShippingAddressChange()"
              (next)="goToStep(3)">
            </app-delivery-step>

            <!-- ── Étape 3 : Paiement ───────────────────────────────────────── -->
            <div id="checkout-step-3" class="checkout-accordion mb-3"
                 [class.checkout-accordion--open]="state.checkoutStep === 3">
              <div class="checkout-accordion__header" (click)="goToStep(3)">
                <span class="ca-badge">3</span>
                <span class="ca-title">{{'PRODUCTS.PAYMENTS_MEANS' | translate}}</span>
                <i class="fas ca-chevron"
                   [class.fa-chevron-up]="state.checkoutStep === 3"
                   [class.fa-chevron-down]="state.checkoutStep !== 3"></i>
              </div>
              <div class="checkout-accordion__body" *ngIf="state.checkoutStep === 3">
                <p class="mb-3 redInfos text-center">{{'PRODUCTS.PAYMENTS_MEANS' | translate}}</p>
                <div class="payment-block mb-3" *ngIf="state.deliveryMode === 'pickup'">
                  <p class="payment-block-title"><i class="fas fa-mobile-alt mr-2"></i>{{ 'PRODUCTS.PAYMENT_LOCAL_TITLE' | translate }}</p>
                  <p class="payment-block-detail" [innerHTML]="'PRODUCTS.PAYMENT_LOCAL_DETAIL' | translate"></p>
                </div>
                <div class="payment-block" *ngIf="state.deliveryMode === 'shipping'">
                  <p class="payment-block-title"><i class="fas fa-globe mr-2"></i>{{ 'PRODUCTS.PAYMENT_INTL_TITLE' | translate }}</p>
                  <p class="payment-block-detail" [innerHTML]="'PRODUCTS.PAYMENT_INTL_DETAIL' | translate"></p>
                </div>
                <p class="mt-3 mb-0 text-center small text-muted">{{ 'PRODUCTS.PAYMENT_CONFIRM_NOTE' | translate }}</p>
                <div class="ca-next-bar">
                  <button class="btn-step-next" (click)="state.checkoutStep = 0">
                    OK <i class="fas fa-check ml-2"></i>
                  </button>
                </div>
              </div>
            </div>

          </div>
          <!--Grid column-->
          <hr class="mb-4">
          <!--Grid column-->
          <div class="col-lg-4">
            <app-order-summary
              [itemLines]="itemLines"
              [nbSelectedItems$]="nbSelectedItems$"
              [cartTotal]="cartTotal"
              [cartTva]="cartTva"
              [deliveryMode]="state.deliveryMode"
              [pickupSubMode]="state.pickupSubMode"
              [shippingCostEur]="shippingCostEur"
              [appliedPromo]="state.appliedPromo"
              [promoDiscountFormatted]="promoDiscountFormatted"
              [promoCodeInput]="state.promoCodeInput"
              [promoValidationStatus]="state.promoValidationStatus"
              [orderStatuses]="state.orderStatuses"
              [statusLabels]="statusLabels"
              [statusColors]="statusColors"
              [canSend]="canSend"
              [hasOutOfStockItems]="hasOutOfStockItems"
              [commendAllreadySent]="state.commendAllreadySent"
              [activeOrder]="activeOrder"
              [courierAgreementChecked]="state.courierAgreementChecked"
              [isShippingAddressValid]="isShippingAddressValid"
              (sendCommand)="sendCommand()"
              (applyPromoCode)="applyPromoCode()"
              (clearPromoCode)="clearPromoCode()"
              (promoCodeInputChange)="state.promoCodeInput = $event">
            </app-order-summary>
          </div>
        </div>
      </section>
    </div>
  </main>
</div>

<!-- Lightbox -->
<div *ngIf="state.lightboxSrc" class="cart-lightbox-overlay" (click)="closeLightbox()">
  <img [src]="state.lightboxSrc" class="cart-lightbox-img" (click)="$event.stopPropagation()" />
  <button class="cart-lightbox-close" (click)="closeLightbox()">✕</button>
</div>
